import { Section } from '../layout/Section';
import { SectionHeader } from '../layout/SectionHeader';
import { Card } from '../ui/Card';
import { Icon } from '../ui/Icon';
import { Button } from '../ui/Button';
import { RevealGroup, RevealItem } from '../ui/Reveal';
import { keyFeatures } from '../../data/landing';
import styles from './KeyFeatures.module.css';

export function KeyFeatures() {
  return (
    <Section id="features" tone="alt">
      <SectionHeader
        eyebrow={keyFeatures.eyebrow}
        title={keyFeatures.title}
        subtitle={keyFeatures.subtitle}
        align="start"
      />

      <RevealGroup className={styles.grid} as="ul">
        {keyFeatures.items.map((item) => (
          <RevealItem key={item.title} as="li" style={{ display: 'flex' }}>
            <Card elevation="raised" hoverable className={styles.card}>
              <span className={styles.badge}>
                <Icon name={item.icon} size={36} />
              </span>
              <div>
                <h3 className={styles.title}>{item.title}</h3>
                <p className={styles.subtitle}>{item.subtitle}</p>
              </div>
            </Card>
          </RevealItem>
        ))}
      </RevealGroup>

      <div className={styles.cta}>
        <Button to={keyFeatures.cta.to} icon="arrow-right-circle">
          {keyFeatures.cta.label}
        </Button>
      </div>
    </Section>
  );
}
